// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--gjQAe";
export var metadata = "styles-module--metadata--tczBz";
export var published = "styles-module--published--FfJes";
export var readTime = "styles-module--read-time--aoqL4";
export var tag = "styles-module--tag--6xXX+";